<template>
    <section class="main-slider">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <b-carousel
                            id="carousel-0"
                            v-model="slide"
                            :interval="4000"
                            controls
                            indicators>
                        <b-carousel-slide v-for="(item, index) in images" :key="index">
                            <template v-slot:img>
                                <picture>
                                    <source media="(min-width: 768px)" :srcset="item.image.srcset">
                                    <img
                                            class="d-block сol-2"
                                            :src="item.image.src"
                                            alt="image slot"
                                    >
                                </picture>
                            </template>
                        </b-carousel-slide>
                    </b-carousel>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "MainSlider",
        data() {
            return {
                slide: 0,
                sliding: null,
                images: [
                    {
                        image: {
                            src: 'img/main-slide-first.png',
                            srcset: 'img/main-slide-first.png',
                        }
                    },
                    {
                        image: {
                            src: 'img/main-slide-second.png',
                            srcset: 'img/main-slide-second.png',
                        }
                    },
                    {
                        image: {
                            src: 'img/main-slide-third.png',
                            srcset: 'img/main-slide-third.png',
                        }
                    },
                    {
                        image: {
                            src: 'img/main-slide-fourth.png',
                            srcset: 'img/main-slide-fourth.png',
                        }
                    }
                ],
            }
        }
    }
</script>

<style lang="scss">
    .main-slider {
        overflow: hidden;

        .d-block {
            width: 100%;
            height: 100%;
        }
        .carousel-inner {
            border-radius: 10px;
        }
        .carousel-indicators {
            li {
                width: 10px;
                height: 10px;
                border-radius: 50%;
                outline: none;

                @media screen and (min-width: $desktop) {
                    width: 18px;
                    height: 18px;
                    margin-right: 6px;
                    margin-left: 6px;
                }
            }
        }
        .carousel-control-prev {
            @media screen and (min-width: $desktop) {
                left: -7%;
            }
        }

        .carousel-control-next {
            right: 50%;

            @media screen and (min-width: $desktop) {
                right: -7%;
            }
        }

        .carousel-control-prev-icon {
            display: none;

            @media screen and (min-width: $desktop) {
                display: block;
                width: 70px;
                height: 70px;
                margin-top: 0;
                background-image: url("data:image/svg+xml,%3Csvg width='50' height='50' viewBox='0 0 50 50' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg filter='url(%23filter0_b)'%3E%3Ccircle cx='25' cy='25' r='25' transform='rotate(180 25 25)' fill='white'/%3E%3C/g%3E%3Cg clip-path='url(%23clip0)'%3E%3Cpath d='M12.8116 25.626L17.4841 30.2985C17.7004 30.5244 17.9944 30.6597 18.3067 30.6771C18.619 30.6944 18.9262 30.5925 19.1662 30.3919C19.2866 30.2838 19.3837 30.1523 19.4517 30.0054C19.5196 29.8585 19.5569 29.6993 19.5612 29.5375C19.5656 29.3758 19.537 29.2148 19.4771 29.0645C19.4172 28.9141 19.3273 28.7776 19.2129 28.6631L17.101 26.5511C17.0486 26.4982 17.0129 26.431 16.9985 26.3579C16.9841 26.2849 16.9916 26.2092 17.0201 26.1403C17.0485 26.0715 17.0966 26.0125 17.1584 25.9709C17.2202 25.9293 17.2928 25.9068 17.3673 25.9063L36.8842 25.9063C37.0379 25.9016 37.189 25.8662 37.3288 25.8022C37.4685 25.7382 37.5941 25.647 37.6981 25.5338C37.8022 25.4207 37.8825 25.2879 37.9345 25.1432C37.9865 24.9986 38.0091 24.845 38.0009 24.6915C38.0223 24.5408 38.0103 24.3873 37.9657 24.2418C37.9211 24.0964 37.8451 23.9625 37.743 23.8497C37.6409 23.7369 37.5152 23.6479 37.3749 23.5891C37.2345 23.5303 37.083 23.503 36.9309 23.5094L17.3346 23.5094C17.2621 23.5045 17.1925 23.4789 17.1342 23.4356C17.0758 23.3923 17.0312 23.3332 17.0055 23.2652C16.9799 23.1972 16.9744 23.1232 16.9897 23.0522C17.0049 22.9812 17.0403 22.916 17.0916 22.8646L19.1569 20.7993C19.3824 20.5816 19.517 20.2865 19.5335 19.9734C19.55 19.6604 19.4471 19.3527 19.2456 19.1126C19.1379 18.9923 19.0068 18.8952 18.8603 18.8274C18.7138 18.7595 18.555 18.7223 18.3936 18.7179C18.2322 18.7135 18.0717 18.7421 17.9217 18.8019C17.7717 18.8618 17.6356 18.9516 17.5215 19.0658L12.8116 23.7757C12.6896 23.8969 12.5927 24.041 12.5266 24.1998C12.4605 24.3586 12.4265 24.5288 12.4265 24.7008C12.4265 24.8728 12.4605 25.0431 12.5266 25.2019C12.5927 25.3607 12.6896 25.5048 12.8116 25.626Z' fill='black'/%3E%3C/g%3E%3Cdefs%3E%3Cfilter id='filter0_b' x='-3.68605' y='-3.68605' width='57.3721' height='57.3721' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeGaussianBlur in='BackgroundImage' stdDeviation='1.84302'/%3E%3CfeComposite in2='SourceAlpha' operator='in' result='effect1_backgroundBlur'/%3E%3CfeBlend mode='normal' in='SourceGraphic' in2='effect1_backgroundBlur' result='shape'/%3E%3C/filter%3E%3CclipPath id='clip0'%3E%3Crect width='25.5724' height='11.9475' fill='white' transform='translate(38 30.6666) rotate(180)'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A");
                border-radius: 50%;
                background-color: #FBFBFB;
            }
        }

        .carousel-control-next-icon {
            display: none;

            @media screen and (min-width: $desktop) {
                display: block;
                width: 70px;
                height: 70px;
                margin-top: 0;
                background-image: url("data:image/svg+xml,%3Csvg width='51' height='50' viewBox='0 0 51 50' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg filter='url(%23filter0_b)'%3E%3Ccircle cx='25.1133' cy='25' r='25' fill='white'/%3E%3C/g%3E%3Cg clip-path='url(%23clip0)'%3E%3Cpath d='M37.3014 24.3738L32.6289 19.7013C32.4126 19.4754 32.1186 19.3401 31.8063 19.3227C31.494 19.3054 31.1868 19.4073 30.9468 19.6079C30.8264 19.716 30.7293 19.8475 30.6614 19.9944C30.5935 20.1413 30.5562 20.3005 30.5518 20.4622C30.5474 20.624 30.5761 20.785 30.6359 20.9353C30.6958 21.0857 30.7857 21.2222 30.9001 21.3367L33.0121 23.4487C33.0645 23.5016 33.1001 23.5688 33.1145 23.6419C33.1289 23.7149 33.1214 23.7906 33.093 23.8595C33.0645 23.9283 33.0164 23.9872 32.9547 24.0289C32.8929 24.0705 32.8202 24.093 32.7457 24.0935H13.2288C13.0752 24.0982 12.924 24.1336 12.7843 24.1976C12.6445 24.2616 12.5189 24.3528 12.4149 24.466C12.3109 24.5791 12.2305 24.7119 12.1785 24.8566C12.1265 25.0012 12.1039 25.1548 12.1121 25.3083C12.0907 25.4589 12.1027 25.6125 12.1473 25.7579C12.1919 25.9034 12.2679 26.0373 12.3701 26.1501C12.4722 26.2629 12.5978 26.3519 12.7382 26.4107C12.8785 26.4695 13.0301 26.4967 13.1821 26.4904H32.7784C32.8509 26.4953 32.9205 26.5208 32.9789 26.5641C33.0372 26.6074 33.0819 26.6666 33.1075 26.7346C33.1331 26.8026 33.1386 26.8765 33.1234 26.9476C33.1081 27.0186 33.0727 27.0838 33.0214 27.1352L30.9562 29.2005C30.7306 29.4182 30.596 29.7133 30.5795 30.0264C30.563 30.3394 30.6659 30.6471 30.8674 30.8872C30.9751 31.0075 31.1062 31.1045 31.2527 31.1724C31.3992 31.2403 31.558 31.2775 31.7194 31.2819C31.8808 31.2863 32.0414 31.2577 32.1913 31.1979C32.3413 31.138 32.4775 31.0482 32.5915 30.934L37.3014 26.2241C37.4234 26.1029 37.5203 25.9588 37.5864 25.8C37.6525 25.6412 37.6866 25.4709 37.6866 25.299C37.6866 25.127 37.6525 24.9567 37.5864 24.7979C37.5203 24.6391 37.4234 24.495 37.3014 24.3738Z' fill='black'/%3E%3C/g%3E%3Cdefs%3E%3Cfilter id='filter0_b' x='-2.55339' y='-2.66667' width='55.3333' height='55.3333' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeGaussianBlur in='BackgroundImage' stdDeviation='1.33333'/%3E%3CfeComposite in2='SourceAlpha' operator='in' result='effect1_backgroundBlur'/%3E%3CfeBlend mode='normal' in='SourceGraphic' in2='effect1_backgroundBlur' result='shape'/%3E%3C/filter%3E%3CclipPath id='clip0'%3E%3Crect width='25.5724' height='11.9475' fill='white' transform='translate(12.1133 19.3334)'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A");
                border-radius: 50%;
                background-color: #FBFBFB;
            }
        }
    }
</style>
